import { WarningAmberRounded } from "@mui/icons-material";
import { Alert } from "@mui/material";
import * as React from "react";

type AlertMessageProps = {
  message: string;
  severity: "error" | "warning" | "info" | "success";
  width?: number;
};

const iconsMap = {
  error: <WarningAmberRounded className="!fill-error-main" />,
};
const AlertMessage = ({ message, severity, width = 340 }: AlertMessageProps) => {
  return (
    <div>
      <Alert
        sx={{ width }}
        severity={severity}
        icon={iconsMap[severity]}
        className="flex items-center"
      >
        {message}
      </Alert>

    </div>
  );
};

export default AlertMessage;
